/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable no-unused-vars */
import { useRoutes } from 'react-router';
import { MantineProvider } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { NotificationsProvider } from '@mantine/notifications';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import routes from './router/routes';
import { store } from './store';
import './i18n';
import './App.css';
import LandingLayout from './components/LandingLayout';
import AppContext from './components/Context/index';

const App = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const routeElement = useRoutes(routes);
  const [appState, setAppState] = useState({ language: 'en' });

  useEffect(() => {
    const languageValue = appState?.language;
    i18n.changeLanguage(languageValue);
    document.body.dir = appState?.language === 'ar' ? 'rtl' : 'ltr';
  }, [appState?.language, i18n]);

  return (
    <AppContext.Provider
      value={{
        appState,
        setAppState,
      }}
    >
      <MantineProvider
        className="example"
        withGlobalStyles
        withNormalizeCSS
        theme={{
          breakpoints: {
            xs: 500,
            sm: 800,
            md: 1000,
            lg: 1200,
            xl: 1400,
          },
          // dir: 'rtl',
          // dir: appState?.language === 'ar' ? 'rtl' : 'ltr',
          colors: {
            brand: [
              '#f2f2f2',
              '#e6e6e6',
              '#bfbfbf',
              '#999999',
              '#4d4d4d',
              '#000000',
              '#000000',
              '#000000',
              '#000000',
              '#000000',
            ],
          },
          primaryColor: 'brand',
        }}
      >
        <NotificationsProvider position="top-right">
          <LandingLayout>
            <Provider store={store}>{routeElement}</Provider>
          </LandingLayout>
        </NotificationsProvider>
      </MantineProvider>
    </AppContext.Provider>
  );
};

export default App;
